module.exports = {"id":"201938","name":"Anthony Limbombe","rating":"75","photo":"./data/images/photos/1/201938.png","club":{"name":"Club Bruges","logo":"./data/images/clubs/ClubBruges.png"},"positions":["MG","AG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AnthonyLimbombe0.json
// module id = 426
// module chunks = 0